<template>
  <div class="filter-drawer" :class="{ 'open': isOpen }">
    <div class="filter-drawer-header">
      <h5>Filter Contacts</h5>
      <button type="button" class="close" @click="closeDrawer">
        <span>&times;</span>
      </button>
    </div>
    <div class="filter-drawer-body">
      <!-- First Name Filter -->
      <div class="form-group">
        <label>First Name</label>
        <input
          type="text"
          v-model="filters.firstName"
          class="form-control"
          placeholder="Enter first name"
        />
      </div>

      <!-- Last Name Filter -->
      <div class="form-group">
        <label>Last Name</label>
        <input
          type="text"
          v-model="filters.lastName"
          class="form-control"
          placeholder="Enter last name"
        />
      </div>

      <!-- Email Filter -->
      <div class="form-group">
        <label>Email</label>
        <input
          type="text"
          v-model="filters.contactEmail"
          class="form-control"
          placeholder="Enter email"
        />
      </div>

      <!-- Phone Filter -->
      <div class="form-group">
        <label>Phone</label>
        <input
          type="text"
          v-model="filters.contactPhone"
          class="form-control"
          placeholder="Enter phone number"
        />
      </div>

      <!-- Contact Type Filter -->
      <div class="form-group">
        <label>Type</label>
        <select v-model="filters.relationshipType" class="form-control">
          <option
            v-for="type in contactTypes"
            :key="type.value"
            :value="type.value === 'ALL' ? '' : type.value"
          >
            {{ type.label }}
          </option>
        </select>
      </div>

      <div class="filter-actions">
        <button class="btn btn-block btn-primary" @click="applyFilters">
          Apply Filters
        </button>
        <button class="btn btn-block btn-secondary mt-2" @click="resetFilters">
          Reset Filters
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    initialFilters: {
      type: Object,
      default: () => ({})
    },
    contactTypes: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      filters: {
        firstName: '',
        lastName: '',
        contactEmail: '',
        contactPhone: '',
        relationshipType: ''
      }
    }
  },
  methods: {
    closeDrawer() {
      this.$emit('close')
    },

    applyFilters() {
      // Send back all filters to parent component
      this.$emit('filters-updated', {
        firstName: this.filters.firstName,
        lastName: this.filters.lastName,
        contactEmail: this.filters.contactEmail,
        contactPhone: this.filters.contactPhone,
        relationshipType: this.filters.relationshipType
      })
    },

    resetFilters() {
      this.filters = {
        firstName: '',
        lastName: '',
        contactEmail: '',
        contactPhone: '',
        relationshipType: ''
      };
    }
  },
  watch: {
    initialFilters: {
      handler(newVal) {
        if (newVal) {
          this.filters.firstName = newVal.firstName || '';
          this.filters.lastName = newVal.lastName || '';
          this.filters.contactEmail = newVal.contactEmail || '';
          this.filters.contactPhone = newVal.contactPhone || '';
          this.filters.relationshipType = newVal.relationshipType || '';
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style scoped>
.filter-drawer {
  position: fixed;
  top: 0;
  right: -350px;
  width: 350px;
  height: 100%;
  background-color: #fff;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
  transition: right 0.3s ease;
  z-index: 1050;
  overflow-y: auto;
}

.filter-drawer.open {
  right: 0;
}

.filter-drawer-header {
  padding: 15px;
  border-bottom: 1px solid #e5e5e5;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.filter-drawer-body {
  padding: 15px;
}

.filter-actions {
  margin-top: 30px;
}

.close {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/contacts/ContactsFilterDrawer.vue